// extracted by mini-css-extract-plugin
module.exports = {"send":"styles_send__1jS-9","toggle":"styles_toggle__1GYWw","subTitle":"styles_subTitle__1kr59"};